export default __webpack_public_path__ + "static/media/marker_single.84c1756b.svg";